import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, unref as _unref, mergeProps as _mergeProps, createVNode as _createVNode, withCtx as _withCtx, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveDirective as _resolveDirective, openBlock as _openBlock, createBlock as _createBlock, withDirectives as _withDirectives, isRef as _isRef, createElementBlock as _createElementBlock } from "vue"

import {  ref, Ref, reactive, onBeforeMount } from 'vue'
import { ElMessage, ElMessageBox } from 'element-plus'
import tbMix, {cpyCfig, orgCfig} from '@/global_mixin/tableMixin'
import dayjs from 'dayjs'
import { getNumber } from '@/utils/index'
import Api from '@/http/modules/index'

export default /*#__PURE__*/_defineComponent({
  setup(__props) {

let {
  'POST/salary/check/base_salary': fetchList,
} = Api

const { 
  MI_tableData, fetchData, page, size, MI_total, MI_pageChange,
  MI_sizeChange, MI_identify, MI_params, MI_modifyForm, MI_height
} = new tbMix(fetchList)


const searchConfig = ref([
  {
    label: '姓名',
    upKey: 'key',
    value: '',
    props: {},
  },
  {
    type: "TIME",
    label: "月份",
    value: dayjs().format('YYYY-MM-DD'),
    upKey: 'month',
    props: {
      'value-format': 'YYYY-MM-DD',
      type: 'month',
      clearable: true
    }
  },
  cpyCfig(),
  orgCfig(),
  {
    type: 'SELECT',
    label: '人员类型(差异)',
    value: false,
    upKey: 'difference',
    options: [
      { label: '差异人员', id: true },
      { label: '全部人员', id: false }
    ],
    seleProps: {
      label: 'name',
      valueName: 'id',
    },
    props: { placeholder: '请选择差异类型', clearable: false }
  },
])

// 添加
const addConfig = ref([])
const addFg = ref<boolean>(false)
const addHandle = () => {
  MI_modifyForm({}, addConfig, addFg, async(params: any) => {
    ElMessage.success('成功')
    addFg.value = false
    fetchData(MI_params)
  })
}


return (_ctx: any,_cache: any) => {
  const _component_FlexibleForm = _resolveComponent("FlexibleForm")!
  const _component_el_collapse_item = _resolveComponent("el-collapse-item")!
  const _component_el_collapse = _resolveComponent("el-collapse")!
  const _component_el_link = _resolveComponent("el-link")!
  const _component_el_table_column = _resolveComponent("el-table-column")!
  const _component_el_table = _resolveComponent("el-table")!
  const _component_el_pagination = _resolveComponent("el-pagination")!
  const _directive_loading = _resolveDirective("loading")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(_component_el_collapse, null, {
      default: _withCtx(() => [
        _createVNode(_component_el_collapse_item, { title: "薪酬校对-搜索" }, {
          default: _withCtx(() => [
            _createVNode(_component_FlexibleForm, _mergeProps({ ref: "searchForm" }, {
          initSearch: true,
          title: true,
          searchConfig: searchConfig.value,
        }, {
              onSearchFn: _cache[0] || (_cache[0] = ($event: any) => (_unref(fetchData)($event, {}, 1)))
            }), null, 16)
          ]),
          _: 1
        })
      ]),
      _: 1
    }),
    _withDirectives((_openBlock(), _createBlock(_component_el_table, {
      ref: "tb",
      border: "",
      data: _unref(MI_tableData),
      "max-height": _unref(MI_height) + 20 + "px"
    }, {
      default: _withCtx(() => [
        _createVNode(_component_el_table_column, {
          label: "姓名",
          prop: "realName",
          "show-overflow-tooltip": ""
        }, {
          default: _withCtx(({ row }) => [
            _createVNode(_component_el_link, {
              type: "primary",
              onClick: ($event: any) => (_ctx.$router.push({ name: 'salaryModify', params: {userId: row.userId, month: _unref(MI_params).month }}))
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(`${row.realName}(${row.alias})`), 1)
              ]),
              _: 2
            }, 1032, ["onClick"])
          ]),
          _: 1
        }),
        _createVNode(_component_el_table_column, {
          label: "身份证",
          prop: "cardId",
          "show-overflow-tooltip": ""
        }),
        _createVNode(_component_el_table_column, {
          label: "类型",
          prop: "type",
          "show-overflow-tooltip": ""
        }),
        _createVNode(_component_el_table_column, {
          label: "日期",
          prop: "date",
          "show-overflow-tooltip": ""
        }),
        _createVNode(_component_el_table_column, {
          align: "right",
          formatter: (row) => _unref(getNumber)(row.salary.currSalary),
          label: "本月薪酬",
          prop: "salary.currSalary",
          "show-overflow-tooltip": ""
        }, null, 8, ["formatter"]),
        _createVNode(_component_el_table_column, {
          align: "right",
          formatter: (row) => _unref(getNumber)(row.salary.lastSalary),
          label: "上月薪酬",
          prop: "salary.lastSalary",
          "show-overflow-tooltip": ""
        }, null, 8, ["formatter"]),
        _createVNode(_component_el_table_column, {
          align: "right",
          formatter: (row) => _unref(getNumber)(row.salary.diffCostAmount),
          label: "和上月差异",
          sortable: "",
          prop: "salary.diffCostAmount",
          "show-overflow-tooltip": ""
        }, null, 8, ["formatter"]),
        _createVNode(_component_el_table_column, {
          align: "right",
          formatter: (row) => _unref(getNumber)(row.salary.baseSalary),
          label: "基础薪酬",
          prop: "salary.baseSalary",
          "show-overflow-tooltip": ""
        }, null, 8, ["formatter"]),
        _createVNode(_component_el_table_column, {
          align: "right",
          formatter: (row) => _unref(getNumber)(row.salary.baseAndCostDiffAmount),
          label: "和基础差异",
          prop: "salary.baseAndCostDiffAmount",
          "show-overflow-tooltip": ""
        }, null, 8, ["formatter"]),
        _createVNode(_component_el_table_column, {
          align: "right",
          formatter: (row) => _unref(getNumber)(row.insurance.currInsurance),
          label: "本月社保",
          prop: "insurance.currInsurance",
          "show-overflow-tooltip": ""
        }, null, 8, ["formatter"]),
        _createVNode(_component_el_table_column, {
          align: "right",
          formatter: (row) => _unref(getNumber)(row.insurance.lastInsurance),
          label: "上月社保",
          prop: "insurance.lastInsurance",
          "show-overflow-tooltip": ""
        }, null, 8, ["formatter"]),
        _createVNode(_component_el_table_column, {
          align: "right",
          formatter: (row) => _unref(getNumber)(row.insurance.diffInsuranceAmount),
          label: "差异",
          sortable: "",
          prop: "insurance.diffInsuranceAmount",
          "show-overflow-tooltip": ""
        }, null, 8, ["formatter"])
      ]),
      _: 1
    }, 8, ["data", "max-height"])), [
      [_directive_loading, _unref(MI_identify)]
    ]),
    _createVNode(_component_el_pagination, {
      small: "",
      background: "",
      total: _unref(MI_total),
      currentPage: _unref(page),
      "onUpdate:currentPage": _cache[1] || (_cache[1] = ($event: any) => (_isRef(page) ? (page).value = $event : null)),
      "page-size": _unref(size),
      "onUpdate:page-size": _cache[2] || (_cache[2] = ($event: any) => (_isRef(size) ? (size).value = $event : null)),
      class: "mb-5 mt-5",
      "page-sizes": [10, 30, 50],
      layout: "sizes, prev, pager, next, total, jumper",
      onCurrentChange: _unref(MI_pageChange),
      onSizeChange: _unref(MI_sizeChange)
    }, null, 8, ["total", "currentPage", "page-size", "onCurrentChange", "onSizeChange"])
  ]))
}
}

})